import React from 'react';

import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';


import { PageTitle } from '@src/components/common';
import EditAdminUrl from '@src/components/common/Display/EditAdminUrl';
import ExpiredAlert from '@src/components/common/Display/expired-alert';
import StatusLabels from '@src/components/common/Display/titles/StatusLabels';
import { useTrackContentView } from '@src/hooks/effects/useTrackContentView';
import { SafelyRenderHtml } from '@src/services';

import {
    ContentSummary,
    Content,
    ContentInfoHeader,
    Downloads,
    FeaturedImage,
} from './partials';

import '@src/css/article_id.scss';
import '@src/css/post_page.scss';

import './styles.scss';

export const ContentView = (props) => {
    const {
        alertCategory,
        effectiveUntilMsg,
        attachments,
        categories,
        children,
        content,
        expiredAt,
        id,
        resourceType,
        imgUrl,
        agent360,
        products,
        platformProducts,
        publishedAt,
        roleType,
        salesChannels,
        states,
        status,
        title,
        updatedAt,
        contentSummary,
        agencyName,
    } = props;

    useTrackContentView({ id, resourceType, title });

    return (
        <>
            <PageTitle title={title} />
            <Col xs={12}>
                <ExpiredAlert expiredAt={expiredAt} />
            </Col>
            <Col xs={12} id={id} className="post_page content-container content-view-container">
                <Card className="post_page_white_bg">
                    <Card.Header className="p-0 border-0">
                        <EditAdminUrl resourceType={resourceType} id={id} />
                        <h1>
                            <StatusLabels
                                expiredAt={expiredAt}
                                status={status}
                                publishedAt={publishedAt}
                            />
                            {SafelyRenderHtml(title)}
                        </h1>
                        {
                            agent360
                            || <ContentInfoHeader
                                alertCategory={alertCategory}
                                categories={categories}
                                salesChannels={salesChannels}
                                products={products}
                                platformProducts={platformProducts}
                                publishedAt={publishedAt}
                                roleType={roleType}
                                states={states}
                                status={status}
                                updatedAt={updatedAt}
                                effectiveUntilMsg={effectiveUntilMsg}
                                agencyName={agencyName}
                            />
                        }
                        {
                            imgUrl && <FeaturedImage imgUrl={imgUrl} />
                        }
                    </Card.Header>
                    <Card.Body className="p-0">
                        {
                            contentSummary
                            && <ContentSummary content={contentSummary} />
                        }
                        {
                            content
                            && <Content content={content} />
                        }
                        {
                            children
                            && children
                        }
                        {
                            attachments && attachments.length > 0
                            && (
                                <Downloads
                                    attachments={attachments}
                                    resourceType={resourceType}
                                    resourceId={id}
                                />
                            )
                        }
                    </Card.Body>
                </Card>
            </Col>
        </>
    );
};

ContentView.propTypes = {
    alertCategory: PropTypes.string,
    attachments: PropTypes.any,
    effectiveUntilMsg: PropTypes.node,
    expiredAt: PropTypes.string,
    categories: PropTypes.arrayOf(PropTypes.object),
    children: PropTypes.node,
    content: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    resourceType: PropTypes.string,
    imgUrl: PropTypes.string,
    agent360: PropTypes.bool,
    products: PropTypes.arrayOf(PropTypes.shape({
        states: PropTypes.arrayOf(PropTypes.object),
    })),
    platformProducts: PropTypes.arrayOf(PropTypes.object),
    publishedAt: PropTypes.string,
    roleType: PropTypes.string,
    salesChannels: PropTypes.arrayOf(PropTypes.object),
    states: PropTypes.arrayOf(PropTypes.object),
    status: PropTypes.string,
    title: PropTypes.string,
    updatedAt: PropTypes.string,
    contentSummary: PropTypes.string,
    agencyName: PropTypes.string,
};
